import { graphql } from "@/gql";

export const INCIDENTS_QUERY = graphql(`
  query INCIDENTS_QUERY(
    $first: Int
    $offset: Int
    $organizationId: String!
    $search: String
    $createdAt: IncidentsCreatedAtConditionInput
    $status: IncidentsStatusConditionInput
    $priority: IncidentsPriorityConditionInput
    $types: [String!]
    $orderBy: [IncidentsOrderBy!] = ID_DESC
  ) {
    incidents(
      first: $first
      offset: $offset
      condition: {
        organizationId: $organizationId
        createdAt: $createdAt
        search: $search
        status: $status
        priority: $priority
        types: $types
      }
      orderBy: $orderBy
    ) {
      totalCount
      edges {
        node {
          id
          organizationId
          shortId
          subject
          description
          status
          priority
          createdAt
          updatedAt
          contactMemberId
          contactMember {
            id
            fullName
            displayName
            avatarUrl
          }
          ownedByMemberId
          ownedByMember {
            id
            fullName
            displayName
            avatarUrl
          }
          ownedByGroupId
          ownedByGroup {
            id
            name
          }
          incidentTypeId
          incidentType {
            id
            name
            iconSvg
          }
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
      }
    }
  }
`);
